export const gtag_report_conversion_page_view = (url) => {
  var callback = function () {
    if (typeof (url) !== 'undefined' && url !== '') {
      window.location = url;
    }
  };
  // Ensure `gtag` is loaded before calling it
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-923778505/voZqCLO8wcgaEMn7vrgD',
      'event_callback': callback
    });
    console.log("Conversion tracked-page-view");
  } else {
    console.log("Error - Conversion tracked-page-view");
  }
  return false;
};
